import { HStack, Text } from "@chakra-ui/react"
import { useBlocksConfig } from "@pathwright/blocks-engine"
import ResourceBackground from "@pathwright/ui/src/components/background/ResourceBackground"
import DotBackground from "@pathwright/ux/src/components/background/DotBackground"
import Link from "@pathwright/ux/src/components/link/Link"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"

const ContentSourceLink = () => {
  const { tc } = useTranslate()
  const { cohortCustomization, templateVariables } = useBlocksConfig()
  if (!cohortCustomization?.sourceStepUrl) return null

  return (
    <Link
      to={cohortCustomization.sourceStepUrl}
      variant="plain"
      display="flex"
      position="relative"
      overflow="hidden"
      borderBottomRadius="inherit"
      p={4}
      color="white"
      _hover={{ color: "white", textDecoration: "none" }}
    >
      {templateVariables?.resource && (
        <ResourceBackground resource={templateVariables.resource} forceBlur />
      )}
      <DotBackground dotSize={4} dotSpacing={24} />
      <HStack position="relative" gap={2}>
        <Pathicon icon="cloud-arrows-fill" size="16px" />
        <Text fontWeight="bold" fontSize="sm" color="white">
          {tc("Edit shared version in Source Path")}
        </Text>
      </HStack>
    </Link>
  )
}

export default ContentSourceLink
